<template>
  <div id="step_3">
    <img src="">
    <h2 class="text-center">What's your shape?</h2>
    <p>
      Hover over each shape to see more details.
    </p>
    <img_select
            v-for="shape in shapes"
            :key="shape.Value"
            :option="shape"
    ></img_select>
  </div>
</template>

<script>
  import img_select from './img_select.vue';
  import shapes from '../data/shapes';

  export default {
    components: {
      img_select,
    },
    data(){
      return {
        shapes,
      }
    },
  }
</script>
